import { SVGProps, Ref, forwardRef } from 'react';

export const DzenSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.028 15h-.056c-2.78 0-4.405-.28-5.537-1.389C1.269 12.422 1 10.808 1 8.04V7.96c0-2.768.27-4.394 1.435-5.571C3.578 1.28 5.193 1 7.973 1h.056c2.768 0 4.394.28 5.536 1.39C14.731 3.579 15 5.193 15 7.96v.079c0 2.77-.27 4.394-1.435 5.571-1.143 1.11-2.757 1.39-5.537 1.39m5.208-7.206a.1.1 0 0 1 .097.1v.223a.1.1 0 0 1-.097.1c-1.914.073-3.078.316-3.893 1.132-.815.814-1.058 1.977-1.132 3.887a.1.1 0 0 1-.1.096h-.224a.1.1 0 0 1-.1-.096c-.073-1.91-.316-3.073-1.13-3.887-.816-.815-1.98-1.06-3.894-1.132a.1.1 0 0 1-.096-.1v-.223a.1.1 0 0 1 .096-.1c1.914-.072 3.078-.316 3.893-1.131.816-.817 1.06-1.983 1.132-3.9a.1.1 0 0 1 .1-.096h.223a.1.1 0 0 1 .1.096c.073 1.918.316 3.083 1.133 3.9.814.815 1.979 1.059 3.893 1.131"
                fill="currentColor"
            />
        </g>
    </svg>
));
DzenSolidSize16Glyph.displayName = 'DzenSolidSize16Glyph';
